import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ResizeObserver from 'resize-observer-polyfill';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.sections = gsap.utils.toArray(document.querySelectorAll('[id^="volet-"]'));
        this.buttons = gsap.utils.toArray(document.querySelectorAll('.o-button-sticky__item a'));
        this.mainButtonText = this.el.querySelector('.-button-main .o-button__text');

        this.buttons.forEach((button, index) => {
            button.addEventListener('click', (e) => {
                const target = this.sections[index];
                e.preventDefault();
                setTimeout(() => {
                    window.locomotiveScroll.scrollTo(target, { offset: -140 });
                }, 10);
            });
        });

        this.sections.forEach(section => {
            const sectionParent = section.closest('.wp-block-group');

            this.scrollTrigger = ScrollTrigger.create({
                trigger: sectionParent,
                start: 'top 20%',
                end: 'bottom 20%',
                pin: false,
                pinSpacing: false,
                scrub: 1,
                markers: false, // Mettre à true pour debug
                onEnter: () => {
                    this.mainButtonText.innerHTML = section.innerHTML;
                },
                onEnterBack: () => {
                    this.mainButtonText.innerHTML = section.innerHTML;
                },
            });

            let resize_timeout;

            const resize_observer = new ResizeObserver(() => {
                clearTimeout(resize_timeout);
                resize_timeout = setTimeout(() => {
                    ScrollTrigger.refresh();
                }, 11);
            });

            resize_observer.observe(document.querySelector('body'));

            // Fallback for window resize events
            this.handleWindowResize = () => {
                clearTimeout(resize_timeout);
                resize_timeout = setTimeout(() => {
                    ScrollTrigger.refresh();
                }, 11);
            };
            window.addEventListener('resize', this.handleWindowResize);
        });
    }

    destroy() {

    }
}